import { bvModals } from '@/plugins/bvModal'

/**
 * Remove stale builder/modal overlays that can cover the preview page.
 */
export function cleanupPreviewPageOverlays () {
  Object.keys(bvModals).forEach((key) => {
    bvModals[key] = false
  })
  document.body.classList.remove(
    'modal-open',
    'skip-logic-section',
    'skip-logic-fullscreen'
  )
  document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove())
  document.getElementById('awn-compat-modal')?.remove()
}

/**
 * Normalize API survey design row into flat theme fields used by preview components.
 */
export function normalizeSurveyDesignDetails (items) {
  if (!items || Array.isArray(items)) return null

  let design = null
  const raw =
    items.st_survey_design_data ??
    items.survey_design_details?.st_survey_design_data

  if (typeof raw === 'string' && raw.trim()) {
    try {
      design = JSON.parse(raw)
    } catch (e) {
      design = {}
    }
  } else if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    design = { ...raw }
  } else if (items.text_color != null || items.button_color != null) {
    design = { ...items }
  } else {
    design = {}
  }

  if (items.logoUrl) design.logoUrl = items.logoUrl
  else if (design.logo && !design.logoUrl) design.logoUrl = design.logo

  if (items.bgUrl) design.bgUrl = items.bgUrl
  else if (design.bg_image && !design.bgUrl) design.bgUrl = design.bg_image

  if (items.in_survey_Id != null) design.in_survey_Id = items.in_survey_Id
  if (items.in_survey_design_id != null) design.in_survey_design_id = items.in_survey_design_id

  return design
}

/**
 * Apply preview theme CSS variables on body; omit unset values so :root defaults apply.
 */
export function applyPreviewThemeVars (design) {
  const body = document.body
  if (!body || !design || typeof design !== 'object' || Array.isArray(design)) {
    return
  }

  const setOrRemove = (name, value) => {
    if (value != null && value !== '' && String(value) !== 'undefined') {
      body.style.setProperty(name, value)
    } else {
      body.style.removeProperty(name)
    }
  }

  setOrRemove('--textColor', design.text_color)
  setOrRemove('--buttonTextColor', design.button_text_color)
  setOrRemove('--buttonBgColor', design.button_color)

  const bgUrl = design.bgUrl || design.bg_image
  if (bgUrl != null && bgUrl !== '' && String(bgUrl) !== 'undefined') {
    body.style.setProperty('--backgroundImage', `url("${bgUrl}")`)
  } else {
    body.style.removeProperty('--backgroundImage')
  }
}
